import { Modal, ModalClose, Sheet } from "@mui/joy";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import ConfirmPopup from "../../../Components/ConfirmPopup";
import { approve, init } from "../../../config/provider";

import {
  usdtTokenAddress,
  mldTokenAddress,
  metaspaceNFTMarketplaceAddress,
} from "../../../config/data";
import { buyAtFixedPrice, createSignature, maticBuyAtFixedPrice } from "./contractData";
import axios from "axios";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CircularLoader from "../../../Components/CircularLoader/CircularLoader";
import {
  gasEstimateBuy,
  gasEstimateBuyForMatic,
} from "../../../config/gasEstimation";
import environmentVariables from "../../../config/environmentVariables";
import TransactionLoader from "../../../Components/TransactionLoader/TransactionLoader";
import { ethers } from "ethers";
import { userBalanceContext } from "../../../context/userBalanceContext";
import RectangularSkeleton from "../../../Components/SkeletonLoader/SkeletonLoader";
import { buyTokenPopUpContext } from "../../../context/buyTokenPopUpContext";
import { userInfoContext } from "../../../context/userInfoContext";
import { toast } from "react-toastify";
import { useSocket } from "../../../context/socketContext";
const HashImg = `${environmentVariables?.cdnUrl}HashImg.png`;
const CollectionBoxImgMelee = `${environmentVariables?.cdnUrl}melee.png`;
const CollectionBoxImg = `${environmentVariables?.cdnUrl}gun.png`;
const CollectionBoxChar = `${environmentVariables?.cdnUrl}character.png`;

const NftBidingDetailpage = ({
  rarity,
  nftLoading,
  data,
  allContractDetails,
  setDetailOfNftCentral,
  setAllContractDetails,
  name,
  fetchDetails,
}) => {
  console.log(data?.price, "nftdatainsidegraph");
  const [approvalPopUpShow,setApprovalPopUpShow]=useState(false);
  const classes = useStyles();
  const params = useParams();
  // console.log(params, "balanceofbuy");
  // console.log("nftbidingdetailpages 111", data);
  const [tokenId, setTokenId] = useState(data?.tokenId);
  const [open, setOpen] = React.useState(false);
  const [gasPrice, setGasPrice] = useState(0);
  const [currency, setCurrency] = React.useState("MLD");
  const [loading, setLoading] = useState(false);
  const [approveLoading,setApproveLoading]=useState(false);
  const [message, setMessage] = useState("Insufficient POL");
  const [isEstimateTrans, setIsEstimateTrans] = useState(false);
  const [isListedByUser, setIsListedByUser] = useState(false);
  const [showDepositPopup, setShowDepositPopup] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [transactionHash, setTransactionHash] = useState(null);
  const [transactionFee, setTransactionFee] = useState(null);
  const [lowBalancePopUp, setLowBalancePopup] = useState(false);
  const [approvePopUpForPurchase,setApprovePopUpForPurchase]=useState(false);
  const [initInProgress, setInitInProgress] = useState(false);
  const [lowGasFee, setLowGasFee] = useState(false);
  const { userAccInfo, setUserAccInfo } = useContext(userInfoContext);
  const [isBuyError, setIsBuyError] = useState(false);
  const { setIsBuyOpen, setPopUpCurrency } = useContext(buyTokenPopUpContext);
  const [isNFTError, setIsNFTError] = useState(false);
  const { userBalance, setUserBalance } = useContext(userBalanceContext);
  const navigation = useNavigate();
  const socket = useSocket();
   const balance = {
    USDT: parseInt(allContractDetails?.usdtBal),
    MLD: parseInt(allContractDetails?.mldBal),
    MATIC: parseInt(allContractDetails?.maticBal),
  };

  const allowance = {
    USDT: parseInt(allContractDetails?.usdtMarketPlaceAllowance),
    MLD: parseInt(allContractDetails?.mldMarketPlaceAllowance),
  };

  const address = {
    USDT: usdtTokenAddress,
    MLD: mldTokenAddress,
  };

  const contract = {
    USDT: allContractDetails?.usdtTokenContract,
    MLD: allContractDetails?.mldTokenContract,
    MATIC: allContractDetails?.provider,
  };

  const checkApproval=()=>{
    try{
      let allowancePrice=convertedPrice(
        getTradeCurrency(data?.tradeCurrency),
        allowance[currency]
      )
      if(allowancePrice<data?.price){
        setApprovalPopUpShow(true);
        console.log(true,allowancePrice,data?.price,'kkkkkkkkkkkkkkkkkkkkjjjjjjjjjjjjjdddddddddddd')
      }else{
        setApprovalPopUpShow(false);
        console.log(false,allowancePrice,data?.price,'kkkkkkkkkkkkkkkkkkkkjjjjjjjjjjjjjdddddddddddd')
      }
    }catch(err){
      console.log(err)
    }
  }
  useEffect(()=>{
    if(currency&&currency.toLowerCase()!="pol"){
      checkApproval();
      
    }
  },[allowance,data,currency])
  const addErrorLogs = async (type, error) => {
    try {
      let data = {
        type: type,
        error: error,
        user_address: allContractDetails?.address,
      };

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/add_error_log`,
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${userAccInfo}`,
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (err) {
      console.log(err);
    }
  };
  // useEffect(() => {
  //   if (params.tokenId) {
  //     setTokenId(params.tokenId);
  //   }
  // }, [params]);
  const buyAtFixedPriceNFT=async ()=>{
   try{
      const res=await createSignature(
        allContractDetails?.signatureCreationContract,
        allContractDetails?.address,
        params.contract,
        tokenId || data?.tokenId,
        data?.tradeCurrency || fetchDetails?.currency,
        data?.price || fetchDetails?.price,
        allContractDetails?.signer,
        allContractDetails?.provider
      )
      console.log(res, "purchasedata--------------------------------------------->signature");
      if (res) {
        const dataNew = {
          userAddress: allContractDetails?.address,
          nftContract: params.contract,
          tokenId: data?.tokenId,
          signedMessageHash:res?.signedMessageHash,
          signature:res?.signature
        };
        const config={
          method:"post",
          url:`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/gasless/purchase`,
          data:dataNew
        }
        const response = await axios.request(config);
        // setLoading(false);
        console.log(response,'purchasedata--------------------------------------------->')
      }else{
        setIsBuyError(true);
        setMessage("Error while buying NFT, please try again later.");
        addErrorLogs("buy", "Signature creation failed");
        return;
      }
   }catch(err){
    console.log(err, "purchasedata--------------------------------------------->");
    setIsBuyError(true);
    setMessage("Error while buying NFT, please try again later.");
    addErrorLogs("buy", err?.message || "Unknown error");
   } 
  }
  useEffect(() => {
    if (allContractDetails?.address) {
     
      
      socket.on("purchase-success", (data) => {
        // console.log(
        //   "purchasedata--------------------------------------------->",
        //   data
        // );
        if(data?.data=="error"){
          setIsBuyError(true);
          setMessage("NFT purchase is pending, please check in your NFTs after some time.");
          addErrorLogs("buy", "Purchase failed");
          setLoading(false);
          triggerPusher(allContractDetails?.address);
           axios
          .get(
            `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/cleardata`
          )
          .then((res) => console.log(res))
          .catch((err) => console.log(err));

        }else{
          axios
          .get(
            `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/cleardata`
          )
          .then((res) => console.log(res))
          .catch((err) => console.log(err));
        setShowDepositPopup(true);
        // setTimeout(() => {
        //   navigation("/nftMarket");
        // }, 5000);
        setLoading(false);
        triggerPusher(allContractDetails?.address);
        }
      });
    }
    return ()=>{
      socket.off("purchase-success")
    }
  }, [allContractDetails,socket]);
  const addInitiatedTransactions = async (contract, token) => {
    try {
      let data = {
        type: "buy",
        user_address: allContractDetails?.address,
        contract_address: contract,
        token_id: token,
      };

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/add_initiated_trxs`,
        headers: {
          authorization: `Bearer ${userAccInfo}`,
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error, "initiated transaction error");
        });
    } catch (err) {
      console.log(err, "initiated transaction error");
    }
  };
  const getAvailableNFTs = async () => {
    try {
      const availableNFTs = await axios.get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_all_nfts/${data?.skinId}?price=${data?.price}&currency=${data?.currency}`,
        { headers: { authorization: `Bearer ${userAccInfo}` } }
      );

      return availableNFTs?.data?.data;
    } catch (err) {
      console.log(err);
      return [];
    }
  };
  const unlockNFT = async () => {
    try {
      let id = tokenId || data?.tokenId;
      const data1 = await axios.get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/unlock_nft/${params.contract}/${id}`,
        { headers: { authorization: `Bearer ${userAccInfo}` } }
      );
      console.log(data1);
    } catch (err) {
      console.log(err);
    }
  };
  const checkAvailableNFT = async (tokenId) => {
    try {
      const firstResponse = await axios.get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/check_is_listed_nft/${params.contract}/${tokenId}`,
        { headers: { authorization: `Bearer ${userAccInfo}` } }
      );

      if (firstResponse?.data?.success) {
        const checkLockedStatus = await axios.get(
          `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/is_locked_nft/${params.contract}/${tokenId}?user=${allContractDetails?.address}`,
          { headers: { authorization: `Bearer ${userAccInfo}` } }
        );
        if (checkLockedStatus?.data?.success) {
          const secondResponse = await axios.get(
            `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/lock_nft/${params.contract}/${tokenId}?user=${allContractDetails?.address}`,
            { headers: { authorization: `Bearer ${userAccInfo}` } }
          );

          if (secondResponse?.data?.success) {
            return true;
          } else {
            // setIsNFTError(true);
            // setMessage("NFT not available, please try again later");
            const availableNFTs = await getAvailableNFTs();
            if (Array.isArray(availableNFTs) && availableNFTs.length>0) {
              const randomIndex = Math.floor(Math.random() * availableNFTs.length);
              setTokenId(availableNFTs[randomIndex]);
              console.log(availableNFTs, "availablenfts");
              handleBuy(availableNFTs[randomIndex]);
              return false;
              // setTokenId(availableNFTs[0]);
              // console.log(availableNFTs, "availablenfts");
              // handleBuy(availableNFTs[0]);
              // return false;
            } else {
              setIsNFTError(true);
              setMessage(
                "NFT not available at the moment, please try again later."
              );
              setIsEstimateTrans(false);
              setInitInProgress(false);
              return false;
            }
          }
        } else {
          // setIsNFTError(true);
          // setMessage("NFT not available, please try again later");
          const availableNFTs = await getAvailableNFTs();
          if (Array.isArray(availableNFTs) && availableNFTs.length>0) {
            const randomIndex = Math.floor(Math.random() * availableNFTs.length);
            setTokenId(availableNFTs[randomIndex]);
            console.log(availableNFTs, "availablenfts");
            handleBuy(availableNFTs[randomIndex]);
            return false;
          } else {
            setIsNFTError(true);
            setMessage(
              "NFT not available at the moment, please try again later."
            );
            setIsEstimateTrans(false);
            setInitInProgress(false);
            return false;
          }
        }
      } else {
        // setIsNFTError(true);
        // setMessage(firstResponse?.data?.message);
        const availableNFTs = await getAvailableNFTs();
        if (Array.isArray(availableNFTs) && availableNFTs.length>0) {
          const randomIndex = Math.floor(Math.random() * availableNFTs.length);
          setTokenId(availableNFTs[randomIndex]);
          console.log(availableNFTs, "availablenfts");
          handleBuy(availableNFTs[randomIndex]);
          return false;
        } else {
          setIsNFTError(true);
          setMessage(
            "NFT not available at the moment, please try again later."
          );
          setIsEstimateTrans(false)
          setInitInProgress(false);
          return false;
        }
      }
    } catch (error) {
      console.log(error);
      // setIsNFTError(true);

      // setMessage("NFT not available, please try again later");
      const availableNFTs = await getAvailableNFTs();
      if (Array.isArray(availableNFTs) && availableNFTs.length>0) {
        const randomIndex = Math.floor(Math.random() * availableNFTs.length);
        setTokenId(availableNFTs[randomIndex]);
        console.log(availableNFTs, "availablenfts");
        handleBuy(availableNFTs[randomIndex]);
        return false;
      } else {
        setIsNFTError(true);
        setMessage("NFT not available at the moment, please try again later.");
        setIsEstimateTrans(false);
        setInitInProgress(false);
        return false;
      }
    }
  };
  const triggerPusher = (address) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/trigger_event`,
      headers: {},
      data: {address:address.toLowerCase()},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
 
  useEffect(() => {
    if (data?.tradeCurrency) {
      setCurrency(getTradeCurrency(data?.tradeCurrency));
    } else {
      setCurrency(fetchDetails?.currency);
    }
  }, [data]);
  useEffect(() => {
    if (allContractDetails?.address) {
      if (
        data?.buyer &&
        data?.buyer.toLowerCase() == allContractDetails?.address.toLowerCase()
      ) {
        setIsListedByUser(true);
      } else if (
        data?.owner &&
        data?.owner.toLowerCase() == allContractDetails?.address.toLowerCase()
      ) {
        setIsListedByUser(true);
      } 
      else if (
        fetchDetails?.buyer &&
        fetchDetails?.buyer.toLowerCase() ==
          allContractDetails?.address.toLowerCase()
      ) {
        setIsListedByUser(true);
      } else if (
        fetchDetails?.owner &&
        fetchDetails?.owner.toLowerCase() ==
          allContractDetails?.address.toLowerCase()
      ) {
        setIsListedByUser(true);
      } else if (fetchDetails?.isListed == false || data?.isListed == false) {
        setIsListedByUser(true);
      } else if (data?.isStaked == true || fetchDetails?.isStaked == true) {
        setIsListedByUser(true);
      } else {
        setIsListedByUser(false);
      }
    }
  }, [allContractDetails, data, fetchDetails]);
  const checkIsUSDT = (address) => {
    if (
      address === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F" ||
      address === "USDT"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const convertedPrice = (currency, price) => {
    return checkIsUSDT(currency)
      ? Number(price) / 1000000
      : Number(price) / 1000000000000000000;
  };
  const getPrice = () => {
    if (typeof data?.price == undefined) {
      return (
        <Text CommonPistol>
          {" "}
          Price :
          <TextValue>
            {data?.price && (
              <>
                0<Span>$MLD </Span>
              </>
            )}
          </TextValue>
        </Text>
      );
    } else if (typeof data?.price == "number") {
      return (
        <Text CommonPistol>
          {" "}
          Price :
          <TextValue>
            {data?.price && (
              <>
                {data?.price}
                <Span> {data?.currency=="MLD"||data?.currency=="LORD"?"$":""}{data?.currency} </Span>
              </>
            )}
          </TextValue>
        </Text>
      );
    } else if (typeof data?.price == "object") {
      console.log(data?.price, data?.tradeCurrency, "nftpricedetail");
      return (
        <Text CommonPistol>
          {" "}
          Price :
          <TextValue>
            {data?.price && (
              <>
                {Number(data?.price / 1000000000000000000)}
                <Span> {getTradeCurrency(data?.tradeCurrency)} </Span>
              </>
            )}
          </TextValue>
        </Text>
      );
    }
  };
  const getTradeCurrency = (id) => {
    let answer = "";

    if (id === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F") {
      answer = "USDT";
    }
    if (id === "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6") {
      answer = "MLD";
    }
    if (id === "0x0000000000000000000000000000000000001010") {
      answer = "MATIC";
    }

    return answer;
  };

  const handlePurchase = () => {
    setConfirmOpen(false);
    setLoading(true);
    stakeIfAllowed();
  };
  const convertPriceHex = (price) => {
    const isHex =
      price?._isBigNumber != undefined && price?._isBigNumber != null;
    if (isHex) {
      return Number(price?._hex / 1000000000000000000);
    } else {
      return price;
    }
  };
  const callFixedPrice = async (contract, token) => {
    console.log(contract, token, "detailsofbuy");
    await addInitiatedTransactions(contract, token);
    // await buyAtFixedPriceNFT();
    await buyAtFixedPrice(
      allContractDetails?.metaspaceNFTMarketplaceContract,
      contract,
      token
    )
      .then((data1) => {
        let price = parseInt(data1.price);
        price = price / 1000000000000000000;
        setTransactionHash(data1?.hash || data1?.transactionHash);
        console.log(data1, "responseafterbuy");

        let gasLimitHex = data1?.gasUsed || data1?.effectiveGasPrice?._hex;
        // console.log(gasLimitHex, "responseafterbuy");

        let gasPriceHex = data1?.gasPrice || data1?.gasUsed?._hex;
        // console.log(gasPriceHex, "responseafterbuy");

        let gasLimitBN = ethers.toBigInt(gasLimitHex);
        // console.log(gasLimitBN, "responseafterbuy");

        let gasPriceBN = ethers.toBigInt(gasPriceHex);
        // console.log(gasPriceBN, "responseafterbuy");

        let totalCostWei = Number(gasLimitBN) *Number(gasPriceBN);

        let totalCostEth = ethers.formatEther(totalCostWei.toString());
        let totalCostDecimal = parseFloat(totalCostEth);
        setTransactionFee(totalCostDecimal);

        let config = {
          method: "get",
          maxBodyLength: Infinity,
          url: `https://api.polygonscan.com/api?module=transaction&action=gettxreceiptstatus&txhash=${data1?.hash}&apikey=YE6C5XNX8ZMZN7W34RGVY1A9V8C82SIHGT`,
        };

        axios
          .request(config)
          .then((responsetrxverify) => {
            // console.log((response?.data?.result?.status==1));
            if (responsetrxverify?.data?.result?.status == 1) {
              axios
                .post(
                  `${
                    environmentVariables?.apiUrl
                  }/nftmarketplace/api/v1/changeowner/${contract.toLowerCase()}/${token}`,
                  {
                    owner: allContractDetails?.address.toLowerCase(),
                    price: parseInt(data?.price / 1000000000000000000),
                  },
                  {
                    headers: {
                      authorization: `Bearer ${userAccInfo}`,
                    },
                  }
                )
                .then((response) => {
                  axios
                    .get(
                      `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/cleardata`
                    )
                    .then((res) => console.log(res))
                    .catch((err) => console.log(err));
                  setTimeout(() => {
                    navigation("/nftMarket");
                  }, 5000);
                  setLoading(false);
                  triggerPusher(allContractDetails?.address);

                  setMessage(`Congratulation you buy successfully.`);
                  setShowDepositPopup(true);
                  return data1;
                })
                .catch((err) => {
                  setLoading(false);
                  console.log(err)
                  setMessage("Something went wrong");
                  setIsNFTError(true);
                  return data1;
                });
            } else {
              axios
                .post(
                  `${
                    environmentVariables?.apiUrl
                  }/nftmarketplace/api/v1/changeowner/${contract.toLowerCase()}/${token}`,
                  {
                    owner: allContractDetails?.address.toLowerCase(),
                    price: parseInt(data?.price / 1000000000000000000),
                  },
                  {
                    headers: {
                      authorization: `Bearer ${userAccInfo}`,
                    },
                  }
                )
                .then((response) => {
                  setTimeout(() => {
                    axios
                      .get(
                        `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/cleardata`
                      )
                      .then((res) => console.log(res))
                      .catch((err) => console.log(err));

                    navigation("/mynfts");
                  }, 5000);
                  setLoading(false);
                  triggerPusher(allContractDetails?.address);
                  setMessage(`Congratulation you buy successfully.`);
                  setShowDepositPopup(true);
                  return data1;
                })
                .catch((err) => {
                  setLoading(false);
                  console.log(err)
                  setMessage("Something went wrong");
                  setIsNFTError(true);
                  return data1;
                });
            }
          })
          .catch((error) => {
            console.log(error);
            setMessage("Something went wrong");
            setIsNFTError(true);
          });
      })
      .catch((err) => {
        console.log("err", err);
        addErrorLogs("buyNFT", JSON.stringify(err));
        setLoading(false);
        setMessage(
          err?.response?.data?.message || err?.message || "Something went wrong"
        );
        setIsNFTError(true);
        // setShowDepositPopup(true);
      });
  };
  const getCollectionImage = (contract) => {
    if (contract == "0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532") {
      return (
        <>
          <CollectionImg src={CollectionBoxImgMelee}></CollectionImg>
        </>
      );
    } else if (contract == "0x7eb272ac9b9fec60c5a7921ccc075152a961111c") {
      return (
        <>
          {" "}
          <CollectionImg src={CollectionBoxChar}></CollectionImg>
        </>
      );
    } else if (contract == "0x8fc3dec6148a9924870f205617c9c26b3010243e") {
      return (
        <>
          {" "}
          <CollectionImg src={CollectionBoxImg}></CollectionImg>
        </>
      );
    }
  };
  const handleApproveNFTForPurchase=async ()=>{
    try{
      setApproveLoading(true)
      if(userBalance[`${data?.currency}`]<data?.price){
         setLowBalancePopup(true);
         setLoading(false);
         setApproveLoading(false);
      }
      const allowancePrice=convertedPrice(
            getTradeCurrency(data.tradeCurrency),
            allowance[currency]
          );
      let price = convertedPrice(data?.tradeCurrency, Number(data.price));
      if(allowancePrice<price)
      await approve(contract[currency],metaspaceNFTMarketplaceAddress,allContractDetails?.provider);
      setApproveLoading(false);
      handleBuy(tokenId)
      setApprovePopUpForPurchase(false);
    }catch(err){
      console.log(err)
      setMessage("Something went wrong fetching details")
      setIsNFTError(true);
      setApproveLoading(false);
    }
  }

  const callMaticFixedPrice = async (contract, token) => {
    // console.log(
    //   "allContractDetails?.metaspaceNFTMarketplaceContract",
    //   allContractDetails?.metaspaceNFTMarketplaceContract
    // );
    // console.log("contract", contract);
    // console.log("token", token);
    // console.log("data.price", data.price);
    const nftpriceinwei = ethers.parseUnits(`${data.price}`, "ether");
    await addInitiatedTransactions(contract, token);
    await maticBuyAtFixedPrice(
      allContractDetails?.metaspaceNFTMarketplaceContract,
      contract,
      token,
      nftpriceinwei
    )
      .then((data) => {
        // navigation("/nftMarket");
        // console.log("data", data);
        // setLoading(false);
        // setMessage(`Congratulation you buy successfully.`);
        // setShowDepositPopup(true);
        let price = parseInt(data.price);
        price = price / 1000000000000000000;
        setTransactionHash(data?.hash || data?.transactionHash);

        let gasLimitHex = data?.gasLimit || data?.gasUsed || data?.effectiveGasPrice?._hex;
        // console.log(gasLimitHex, "responseafterbuy");

        let gasPriceHex = data?.gasPrice || data?.gasUsed?._hex;
        // console.log(gasPriceHex, "responseafterbuy");

        let gasLimitBN = ethers.toBigInt(gasLimitHex);
        // console.log(gasLimitBN, "responseafterbuy");

        let gasPriceBN = ethers.toBigInt(gasPriceHex);
        // console.log(gasPriceBN, "responseafterbuy");

        let totalCostWei = Number(gasLimitBN) * Number(gasPriceBN);

        let totalCostEth = ethers.formatEther(totalCostWei.toString());
        let totalCostDecimal = parseFloat(totalCostEth);
        setTransactionFee(totalCostDecimal);
        // setTransactionFee(
        //   (parseFloat(data?.gasLimit || data?.effectiveGasPrice?._hex) *
        //     parseFloat(data?.gasPrice || data?.gasUsed?._hex)) /
        //     1000000000000000000
        // );
        axios
          .post(
            `${
              environmentVariables?.apiUrl
            }/nftmarketplace/api/v1/changeowner/${contract.toLowerCase()}/${token}`,

            {
              owner: allContractDetails?.address.toLowerCase(),
              price: parseInt(data?.price / 1000000000000000000),
            },
            {
              headers: {
                authorization: `Bearer ${userAccInfo}`,
              },
            }
          )
          .then((response) => {
            axios
              .get(
                `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/cleardata`
              )
              .then((res) => console.log(res))
              .catch((err) => console.log(err));

            setTimeout(() => {
              navigation("/nftMarket");
            }, 5000);
            setLoading(false);
            triggerPusher(allContractDetails?.address);
            setMessage(`Congratulation you buy successfully.`);
            setShowDepositPopup(true);

            return data;
          })
          .catch((err) => {
            setLoading(false);
            setMessage(err?.message||"Something went wrong");
            return data;
          });
      })
      .catch((err) => {
        console.log("err", err);
        addErrorLogs("buyNFT", JSON.stringify(err));
        setLoading(false);
        setMessage("Something went wrong");
        // setShowDepositPopup(true);
      });
  };

  async function stakeIfAllowed() {
    setLoading(true);
    let balanceOf = convertedPrice(currency, balance[currency]);

    let allowancePrice = convertedPrice(
      getTradeCurrency(data.tradeCurrency),
      allowance[currency]
    );
    // console.log("pricepricepriceprice", allowancePrice);
    let price = convertedPrice(data?.tradeCurrency, parseInt(data.price));
    // console.log("pricepricepriceprice", price);
    if (userBalance[`${data?.currency}`] >= data?.price) {
      // console.log("pricepricepriceprice",price)
      if (currency === "POL") {
        await callMaticFixedPrice(params.contract, tokenId || data?.tokenId);
      } else {
        if (allowancePrice >= data?.price) {
          await callFixedPrice(params.contract, tokenId || data?.tokenId);
        } else {
          if (allowancePrice < data?.price) {
            // console.log("contract[currency]", contract[currency]);
            // console.log("address[currency]", address[currency]);
            await approve(contract[currency], metaspaceNFTMarketplaceAddress,allContractDetails?.provider);
          }
          await callFixedPrice(params.contract, tokenId || data?.tokenId);
        }
      }
    } else {
      // alert("not enough balance");
      setLowBalancePopup(true);
      setLoading(false);
    }
  }

  const fetchNewNFTDetails= (contract,tokenId)=>{
    axios.get(`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details/${contract}/${tokenId}`)
    .then(response=>{
        setDetailOfNftCentral(response?.data)
    })
    .catch(err=>{
      setMessage("Something went wrong fetching details")
      setIsNFTError(true);
    })
  }

  const handleBuy = async (tokenId) => {
    console.log(tokenId, "forlockunloknft");
    setInitInProgress(true);
    if (allContractDetails) {
      let balanceOf = convertedPrice(currency, balance[currency]);
      let price = convertedPrice(data?.tradeCurrency, Number(data.price));
      console.log(
        balanceOf,
        price,
        data?.price,
        currency,
        data?.price > balanceOf,
        userBalance,
        currency,
        data?.currency,
        userBalance[`${data?.currency}`],
        "oooooooooooooooooooooooooooooooooooooooooooooooooooooo"
      );
      if (data?.price > userBalance[`${data?.currency}`]) {
        // setLowBalancePopup(true);
        setLoading(false);
        setInitInProgress(false);
        setMessage(`Insufficient ${currency||data?.currency}`);
        setPopUpCurrency(currency);
        setIsBuyError(true);
        return;
      } else if (userBalance?.MATIC < 0.05) {
        setLoading(false);
        setInitInProgress(false);
        setMessage("Insufficient POL");
        setPopUpCurrency("MATIC");
        setIsBuyError(true);
        return;
      } else {
        setIsEstimateTrans(true);
        const isAvailable = await checkAvailableNFT(tokenId);
        // console.log(isAvailable, "isavailablenft");
        if (isAvailable == false) {
          // setIsEstimateTrans(false);
          // setInitInProgress(false);
          return;
        }

        if (currency === "POL") {
          const gas = await gasEstimateBuyForMatic(
            params?.contract,
            tokenId,
            allContractDetails?.address,
            data?.price
          );
          // console.log(gas, "gas during buy------------------------");
          setGasPrice(gas?.toFixed(6));
          const estimatedGasFee =
            (parseFloat(gas) * parseFloat(gasPrice)) / 1000000000000000000;
          console.log(
            estimatedGasFee,
            userBalance.MATIC,
            gas,
            gasPrice,
            "balanceofbuy"
          );
          setIsEstimateTrans(false);
          // setConfirmOpen(true);
          // setInitInProgress(false);
          // console.log(userBalance.MATIC, "maticbalanceofbuy");
          if (estimatedGasFee == undefined || estimatedGasFee == null) {
            // setMessage(
            //   "Unable to Estimate Gas fee, transaction may fail. Buy a different NFT or Try again Later!"
            // );
            // setIsNFTError(true);
            handleBuy(tokenId)
            return;
          }
          if (estimatedGasFee <= userBalance.MATIC) {
            fetchNewNFTDetails(params?.contract,tokenId);
            setConfirmOpen(true);
            setTimeout(() => {
              setConfirmOpen(false);
            }, 600000);
            setInitInProgress(false);
          } else if (
            Number(data?.price) + Number(estimatedGasFee) >=
            userBalance.MATIC
          ) {
            setMessage("Insufficient POL");
            setPopUpCurrency("MATIC");
            setIsBuyError(true);
            return;
          } else if (userBalance.MATIC < 0.03) {
            setMessage("Insufficient POL");
            setPopUpCurrency("MATIC");
            setIsBuyError(true);
            return;
          } else {
            // alert("Gas fee is too high. You don't have enough Matic to cover the gas fee.");
            // setLowGasFee(true);
            // setInitInProgress(false);
            handleBuy(tokenId)
            return;
          }
        } else {
          setIsEstimateTrans(true);
          let allowancePrice = convertedPrice(
            getTradeCurrency(data.tradeCurrency),
            allowance[currency]
          );
          if (allowancePrice < price) {
            try {
              await approve(contract[currency], metaspaceNFTMarketplaceAddress,allContractDetails?.provider);
            } catch (err) {
              console.log(err);
            }
          }
          const gas = await gasEstimateBuy(
            params?.contract,
            tokenId,
            allContractDetails?.address
          );
          // console.log(gas, "gas during buy------------------------");
          setGasPrice(gas?.toFixed(6));

          const estimatedGasFee =
            (parseFloat(gas) * parseFloat(gasPrice)) / 1000000000000000000;
          // console.log(userBalance.MATIC, "maticbalanceofbuy");
          setIsEstimateTrans(false);

          if (estimatedGasFee == undefined || estimatedGasFee == null) {
            handleBuy(tokenId)
            return;
            // setMessage(
            //   "Unable to Estimate Gas fee, transaction may fail. Buy a different NFT or Try again Later!"
            // );
            // setIsNFTError(true);
          }
          if (estimatedGasFee <= userBalance.MATIC) {
            fetchNewNFTDetails(params?.contract,tokenId)
            setConfirmOpen(true);
            setTimeout(() => {
              setConfirmOpen(false);
            }, 600000);
            setInitInProgress(false);
          } else if (userBalance.MATIC < 0.03) {
            setMessage("Insufficient POL");
            setPopUpCurrency("MATIC");
            setIsBuyError(true);
            setInitInProgress(false);
          } else {
            // alert("Gas fee is too high. You don't have enough Matic to cover the gas fee.");
            // setLowGasFee(true);
            // setInitInProgress(false);
            handleBuy(tokenId)
            return;
          }
        }
      }
    } else {
      setInitInProgress(true);
      setTimeout(() => {
        setInitInProgress(false);
      }, 2500);
      init()
        .then((res) => {
          setAllContractDetails(res);
          setInitInProgress(false);
        })
        .catch((err) => {
          // alert(err?.message);
          toast.error(err?.message||"Something went wrong during wallet connection");
          setInitInProgress(false);
        })
        .finally(() => {
          setInitInProgress(false);
        });
    }
  };
  return (
    <>
      {nftLoading == true ? (
        <>
          <RectangularSkeleton />
        </>
      ) : (
        <>
          <Root>
            {loading && <TransactionLoader />}
            {isEstimateTrans && <TransactionLoader isEstimate={true} />}
            <Container>
              <DialogStyledUpdate
                open={lowBalancePopUp}
                onClose={() => setLowBalancePopup(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                  sx: { overflow: "initial", backgroundColor: "transparent" },
                }}
              >
                <ButtonCancel
                  onClick={() => setLowBalancePopup(false)}
                  color="primary"
                >
                  X
                </ButtonCancel>
                <div className={classes.customButton}>
                  {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}

                  <NftNameConfirm>
                    <NftNameConfirmHead>
                      Insufficient Balance
                    </NftNameConfirmHead>
                  </NftNameConfirm>

                  {/* <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead2>0.015 Matic</NftAmountConfirmSubHead2>
              </NftAmountConfirmHeadPur> */}
                  {/* <DialogActions>
                <PayButtons>
                  
                  <ButtonConfirm onClick={handlePurchase} color="primary" autoFocus>
                    Confirm
                  </ButtonConfirm>
                </PayButtons>
              </DialogActions> */}
                </div>
              </DialogStyledUpdate>

              <DialogStyledUpdate
                open={lowGasFee}
                onClose={() => setLowGasFee(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                  sx: { overflow: "initial", backgroundColor: "transparent" },
                }}
              >
                <ButtonCancel
                  onClick={() => setLowGasFee(false)}
                  color="primary"
                >
                  X
                </ButtonCancel>
                <div className={classes.customButton}>
                  {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}

                  <NftNameConfirm>
                    <NftNameConfirmHead>Insufficient POL</NftNameConfirmHead>
                  </NftNameConfirm>

                  {/* <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead2>0.015 Matic</NftAmountConfirmSubHead2>
              </NftAmountConfirmHeadPur> */}
                  {/* <DialogActions>
                <PayButtons>
                  
                  <ButtonConfirm onClick={handlePurchase} color="primary" autoFocus>
                    Confirm
                  </ButtonConfirm>
                </PayButtons>
              </DialogActions> */}
                </div>
              </DialogStyledUpdate>

              <DialogStyledUpdate
                open={isBuyError}
                onClose={() => {
                  setIsBuyError(false);
                  setIsBuyOpen(false);
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                  sx: { overflow: "initial", backgroundColor: "transparent" },
                }}
              >
                <ButtonCancel
                  onClick={() => {
                    setIsBuyError(false);
                    setIsBuyOpen(false);
                  }}
                  color="primary"
                >
                  X
                </ButtonCancel>
                <div className={classes.customButton}>
                  {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}

                  <NftNameConfirm>
                    <NftNameConfirmHead>{message}</NftNameConfirmHead>
                    <BuyPop
                      onClick={() => {
                        setIsBuyOpen(true);
                        setIsBuyError(false);
                        setTimeout(() => {
                          setIsBuyOpen(false);
                        }, 1000);
                      }}
                    >
                      Click here to Buy
                    </BuyPop>
                  </NftNameConfirm>

                  {/* <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead2>0.015 Matic</NftAmountConfirmSubHead2>
              </NftAmountConfirmHeadPur> */}
                  {/* <DialogActions>
                <PayButtons>
                  
                  <ButtonConfirm onClick={handlePurchase} color="primary" autoFocus>
                    Confirm
                  </ButtonConfirm>
                </PayButtons>
              </DialogActions> */}
                </div>
              </DialogStyledUpdate>
              <DialogStyledUpdate
                open={isNFTError}
                onClose={() => setIsNFTError(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                  sx: { overflow: "initial", backgroundColor: "transparent" },
                }}
              >
                <ButtonCancel
                  onClick={() => setIsNFTError(false)}
                  color="primary"
                >
                  X
                </ButtonCancel>
                <div className={classes.customButton}>
                  {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}

                  <NftNameConfirm>
                    <NftNameConfirmHead>{message}</NftNameConfirmHead>
                    {/* <BuyPop>Click here to Buy</BuyPop> */}
                  </NftNameConfirm>

                  {/* <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead2>0.015 Matic</NftAmountConfirmSubHead2>
              </NftAmountConfirmHeadPur> */}
                  {/* <DialogActions>
                <PayButtons>
                  
                  <ButtonConfirm onClick={handlePurchase} color="primary" autoFocus>
                    Confirm
                  </ButtonConfirm>
                </PayButtons>
              </DialogActions> */}
                </div>
              </DialogStyledUpdate>
              <Wrapper>
                {nftLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularLoader></CircularLoader>
                  </div>
                ) : (
                  <>
                    <NameWrapper>
                      {/* <SubCategory>SubCategory</SubCategory> */}
                      <NameTextMain>
                        {/* <NftCategory>{fetchDetails.category}</NftCategory> */}
                        <NftCategoryHash>
                          <NftCategory common>
                            {fetchDetails?.category=="uncommon"||fetchDetails?.category=="Uncommon"?"rare":fetchDetails?.category}
                          </NftCategory>
                          <NftHash>
                            <LordImage src={HashImg}></LordImage>{" "}
                            {fetchDetails?.hash}
                          </NftHash>
                        </NftCategoryHash>
                        <NameText>{name}</NameText>
                        {/* <NameText>Fangs of Fury</NameText> */}
                        <CollectionText>
                          {/* {params.contract ==
                          "0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532" ? (
                            <CollectionImg
                              src={CollectionBoxImgMelee}
                            ></CollectionImg>
                          ) : (
                            <CollectionImg
                              src={CollectionBoxImg}
                            ></CollectionImg>
                          )} */}
                          {getCollectionImage(params.contract)}
                          <CollectionTextFlex>
                            <CollectionTextHead>Collection</CollectionTextHead>
                            <CollectionTextName>
                              {params.contract ===
                              "0x8fc3dec6148a9924870f205617c9c26b3010243e"
                                ? "Shootable"
                                : params.contract ===
                                    "0x6b229c5687d00590606f97045ad65d8dfbfe1bdc" ||
                                  params.contract ===
                                    "0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532"
                                ? "Melee"
                                : params.contract ===
                                  "0x7eb272ac9b9fec60c5a7921ccc075152a961111c"
                                ? "Characters"
                                : params.contract ===
                                  "0x69cc97aad84e5aebd72ec147d7b81b72e22c3ece"
                                ? "Vehicle"
                                : null}
                            </CollectionTextName>

                            {/* </CollectionTextName> */}
                          </CollectionTextFlex>
                        </CollectionText>
                      </NameTextMain>
                    </NameWrapper>
                  </>
                )}

                <TextWrapper>
                  {/* <Text> Sale ends May 19, 2023 at 4:34pm </Text> */}
                  {/* <Text CommonPistol> Rarity : {rarity || "Common"} </Text> */}
                  {getPrice()}
                </TextWrapper>
 <Modal
          aria-labelledby="modal-title"
          aria-describedby="modal-desc"
          open={approvePopUpForPurchase}
          onClose={() => {
            setApprovePopUpForPurchase(false);
            setMessage("");
          }}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "#2a2a2a !important",
            backgroundColor: "#00000080 !important",
            color: "#fff ",
          }}
        >
          <Sheet
            variant="outlined"
            sx={{
              width: 600,
              borderRadius: "md",
              p: 3,
              boxShadow: "lg",
              backgroundColor: "#2a2a2a",
              border: "1px solid #484848",
              padding: "50px",
            }}
          >
           
              <TextContractContainer>
                <ContractTextWrapper>
                  <ContractText>Approve for NFT Purchase </ContractText>
                </ContractTextWrapper>
              </TextContractContainer>

              <TextContractContainer>
                <p   style={{
                        color: "#eeeeee",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}>
                  To Purchase your NFT, you must first approve the NFT Purchase contract
                  to use your <span style={{ fontWeight: "600" }}>tokens</span>.
                </p>


                <p   style={{
                        color: "#eeeeee",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}>
                  This approval is only required once. After that, you can purchase
                  multiple NFTs without repeating this step.
                </p>

              
                <p style={{
                        color: "#ffffff",
                        fontWeight: "700",
                        fontSize: "14px",
                      }}>
                 Approval may require a small amount of POL as gas fee.
                </p>
              </TextContractContainer>
              <ButtonWrapper>
                <PopupButton
                  
                  onClick={() => {
                      handleApproveNFTForPurchase();
                  }}
                >
                  { approveLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularLoader />
                    </div>
                  ) : 
                    `Approve `
                }
                </PopupButton>
              </ButtonWrapper>        
          </Sheet>
        </Modal>
                <Modal
                  aria-labelledby="modal-title"
                  aria-describedby="modal-desc"
                  open={open}
                  onClose={() => setOpen(false)}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Sheet
                    variant="outlined"
                    sx={{
                      minWidth: 500,
                      borderRadius: "md",
                      p: 3,
                      boxShadow: "lg",
                    }}
                  >
                    <ModalClose
                      variant="outlined"
                      sx={{
                        boxShadow: "0 2px 12px 0 rgba(0 0 0 / 0.2)",
                        borderRadius: "50%",
                        bgcolor: "background.body",
                      }}
                    />
                    <PopUpContainer>
                      {/* <LeftContainer>
                <ImageWrapper>
                </ImageWrapper>
              </LeftContainer> */}
                      <RightContainer>
                        <HeadingTextWrapper>
                          {/* <HeadingText> BuyNow</HeadingText>
                  <Paragrapgh>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt
                  </Paragrapgh> */}
                        </HeadingTextWrapper>
                        <NftNameContainer>
                          <NftNameWrapper>
                            {/* <NftNameVaue>Heavy Pistol</NftNameVaue>
                    <NftNameVaue> $20 </NftNameVaue> */}
                          </NftNameWrapper>
                          <NftNameWrapper>
                            {/* <NftNameVaue Common> Common </NftNameVaue>
                    <NftNameVaue Common> 1 item </NftNameVaue> */}
                          </NftNameWrapper>
                        </NftNameContainer>
                        {/* <Line /> */}

                        <TotalContainer>
                          <FloorDiscountContainer>
                            <Dropdown> Price: 20</Dropdown>
                          </FloorDiscountContainer>
                        </TotalContainer>

                        <DropdownContainer>
                          <DropDownTextWrapper>
                            <Dropdown>Currency : $MLD </Dropdown>
                            <SelectContainer>
                              {/* <Select>
                        <Option>Matic</Option>
                        <Option>MLD</Option>

                      </Select> */}
                            </SelectContainer>
                          </DropDownTextWrapper>
                          <ButtonWrapper2>
                            <Button2 onClick={() => setOpen(false)}>
                              Confirm
                            </Button2>
                          </ButtonWrapper2>
                        </DropdownContainer>
                      </RightContainer>
                    </PopUpContainer>
                  </Sheet>
                </Modal>
                <DialogStyledUpdate
                  open={confirmOpen}
                  onClose={() => {
                    setConfirmOpen(false);
                    unlockNFT();
                  }}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  PaperProps={{
                    sx: { overflow: "initial", backgroundColor: "transparent" },
                  }}
                >
                  <ButtonCancel
                    onClick={() => {
                      setConfirmOpen(false);
                      unlockNFT();
                    }}
                    color="primary"
                  >
                    X
                  </ButtonCancel>
                  <div className={classes.customButton}>
                    <DialogTitle
                      id="alert-dialog-title"
                      style={{
                        textAlign: "left",
                        fontSize: "28px",
                        fontWeight: "500",
                        padding: "0",
                      }}
                    >
                      Seal the deal
                    </DialogTitle>
                    <DialogContent style={{ padding: "0 0 40px" }}>
                      <DialogContentText
                        id="alert-dialog-description"
                        style={{
                          textAlign: "left",
                          color: "#bbb",
                          fontSize: "16px",
                        }}
                      >
                        Double-check your details to complete the transaction
                      </DialogContentText>
                    </DialogContent>
                    <NftNameConfirm ConfirmPopup={ConfirmPopup}>
                      {/* <NftConfirmImg src={NftConfirmImg2}></NftConfirmImg> */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          textAlign: "start",
                          width: "100%",
                        }}
                      >
                        <NameandcategoriesWrapper>
                          <NftNameConfirmHead>{name}</NftNameConfirmHead>
                          <NftNameConfirmSubHead>
                            {fetchDetails?.category=="uncommon"||fetchDetails?.category=="Uncommon"?"rare":fetchDetails?.category}
                          </NftNameConfirmSubHead>
                        </NameandcategoriesWrapper>

                        <NftNameConfirmHash>
                          # {fetchDetails?.hash}
                        </NftNameConfirmHash>
                      </div>
                    </NftNameConfirm>
                    <NftAmountConfirm>
                      <NftAmountConfirmHead>Amount :</NftAmountConfirmHead>
                      <NftAmountConfirmSubHead>
                        {data?.price && (
                          <>
                            {convertPriceHex(data?.price)}
                            <Span>
                              {" "}
                              {getTradeCurrency(data?.tradeCurrency)=="MLD" ||
                                data?.currency=="MLD"||getTradeCurrency(data?.tradeCurrency)=="LORD"||data?.currency=="LORD"?"$":""}
                              {getTradeCurrency(data?.tradeCurrency) ||
                                data?.currency}
                            </Span>
                          </>
                        )}
                      </NftAmountConfirmSubHead>
                    </NftAmountConfirm>
                    <NftAmountConfirmHeadPur>
                      <NftAmountConfirmHead2>
                        Transaction Fee :
                      </NftAmountConfirmHead2>
                      <NftAmountConfirmSubHead2>
                        {gasPrice
                          ? `${gasPrice} POL`
                          : "transaction may fail!"}
                      </NftAmountConfirmSubHead2>
                    </NftAmountConfirmHeadPur>
                    <DialogActions>
                      <PayButtons>
                        <ButtonConfirm
                          onClick={handlePurchase}
                          color="primary"
                          autoFocus
                        >
                          Confirm
                        </ButtonConfirm>
                      </PayButtons>
                    </DialogActions>
                  </div>
                </DialogStyledUpdate>

              
                  <>
                    {" "}
                    <ButtonWrapper>
                      <Button
                        onClick={(e) => {
                          if(approvalPopUpShow==true){
                            setApprovePopUpForPurchase(true)
                          }else{
                            handleBuy(data?.tokenId);
                          }
                        }}
                        style={userBalance?.loading==true?{opacity:0.3,cursor:"default"}:{opacity:1,cursor:"pointer"}}
                        disabled={userBalance?.loading==true}
                        // disabled={data?.tradeCurrency && data?.price ? false : true}
                      >
                        {initInProgress ? (
                          <InitInProgressWrapper
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              border: "none !important",
                            }}
                          >
                            <CircularLoader />
                          </InitInProgressWrapper>
                        ) : (
                          "Buy Now"
                        )}
                      </Button>
                    </ButtonWrapper>
                  </>
             
              </Wrapper>
            </Container>
            {showDepositPopup && (
              <ConfirmPopup
                popUpText={`NFT Purchased!`}
                fullwidth={true}
                showPopup={showDepositPopup}
                setShowPopup={setShowDepositPopup}
                fetchDetails={fetchDetails}
                transactionHash={transactionHash}
                transactionFee={transactionFee?.toFixed(4)}
                onClickFun={() => {
                  setShowDepositPopup(false);
                }}
                text={`Success`}
                autoClose={false}
                price={fetchDetails?.price}
              ></ConfirmPopup>
            )}
          </Root>
        </>
      )}
    </>
  );
};


const useStyles = makeStyles((theme) => ({
  customButton: {
    padding: "50px",
    backgroundColor: "#2a2a2a",
    border: "1px solid #484848",
    borderRadius: "10px",
    color: "#fff",
    minWidth: "360px",
    "@media (max-width: 768px)": {
      minWidth: "360px",
    },
    "@media (max-width: 600px)": {
      maxWidth: "220px",
      minWidth: "350px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
  },
}));

const Root = styled.div`
  width: 100%;
  /* margin: 0 20px; */
  @media (max-width: 1024px) {
    /* padding: 0 20px; */
    width: 100%;
  }
  @media (max-width: 650px) {
    padding: 0;
  }
`;
const Container = styled.div`
  /* margin-top: 120px;
  @media(max-width:1440px){
    margin-top:80px ;
  }
  @media (max-width: 1260px) {
    margin-top: 40px;
  }
  @media (max-width: 1024px) {
    margin-top: 30px;
  } */
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: right;
  width: 100%;
  flex-direction: column;
  background-color: #151a1c;
  /* background: linear-gradient(
      180deg,
      rgba(249, 249, 249, 0.04) 0%,
      rgba(249, 249, 249, 0.04) 100%
    ); */
  /* border-width: 1px 0px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0px 19px 46px rgba(0, 0, 0, 0.12); */
  border-radius: 10px;
  padding: 30px;
  @media (max-width: 1024px) {
    padding: 20px 30px;
  }
  @media (max-width: 1024px) {
    padding: 20px 30px;
  }
`;

const BuyPop = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 16px;
  font-weight: 600;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: capitalize;
  background-color: #171e22;
  padding: 25px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 35px;
  width: 170px;
  margin-top: 20px;
  cursor: pointer;
  &:hover {
  }
`;
// const BuyPop = styled.div`
//   background: linear-gradient(45deg, #0a5d6e, #00aacd);
//   border-radius: 50px;
//   outline: none;
//   border: none;
//   font-size: 24px;
//   padding: 20px 80px;
//   margin: 40px 0 10px;
//   cursor: pointer;
//   color: #e9e9e9;
//   width: 100%;
//   -webkit-transition: 1s;
//   transition: 1s;
// `;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 30px;
`;
const Text = styled.text`
  font-family: sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  margin: 10px 0;
  color: #6a6a6a;
  ${(p) =>
    p.CommonPistol &&
    `
line-height: 10px;
color: #6a6a6a;
margin-bottom:15px;
font-size: 16px;
font-weight:600;
display:flex;
align-items: flex-start;
flex-direction: column;
`}
`;

const TextValue = styled.div`
  font-weight: 700;
  font-size: 40px;
  line-height: 38px;
  color: #f3f3f3;
  padding-top: 10px;
`;

const Span = styled.span`
  color: #9b9b9b;
  font-size: 16px;
`;

const ButtonWrapper = styled.div`
  width: 100%;
`;

const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
  @media (max-width: 600px) {
    top: -30px;
    ${'' /* right: 85px; */}
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const ButtonConfirm = styled.button`
  background: linear-gradient(45deg, #0a5d6e, #00aacd);
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 24px;
  padding: 20px 80px;
  margin: 40px 0 10px;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const Button = styled.button`
  background: linear-gradient(45deg, #1a6d7e, #04a1c1);
  border-radius: 30px;
  outline: none;
  border: none;
  font-size: 18px;
  padding: 20px 80px;
  margin: 25px 0;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
  &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  }
`;

const PopUpContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #181718;
  border-radius: 15px;
  /* text-align:center; */
`;
const LeftContainer = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;
const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 80px;

  @media (max-width: 1024px) {
    padding: 20px 30px;
  }

  @media (max-width: 930px) {
    padding: 20px 15px;
  }
  @media (max-width: 550px) {
    padding: 20px 55px;
  }
  @media (max-width: 425px) {
    padding: 20px 75px;
  }
`;
const ImageWrapper = styled.div``;
const Image = styled.img``;
const HeadingTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  width: 80%;
  margin: 20px 0;
`;
const HeadingText = styled.text`
  color: white;
  font-family: sans-serif;
  font-weight: 700;
  font-size: 26px;
  line-height: 29px;
  color: #ffffff;
  margin: 20px 0;
`;
const Paragrapgh = styled.text`
  padding: 10px 0;
  font-family: sans-serif;
  /* font-size:16px; */
  @media (max-width: 950px) {
    padding: 10px 0;
    font-size: 16px;
  }
`;
const NftNameContainer = styled.div`
  margin: 5px 0 30px 0;
`;
const NftNameWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const NftNameVaue = styled.text`
  font-weight: 400;
  font-size: 18px;
  font-family: sans-serif;
  line-height: 22px;
  color: #ffffff;
  ${(p) =>
    p.Common &&
    `
color: rgba(255, 255, 255, 0.7);
padding: 5px 0;
font-size:16px;
color:rgba(0,0,0,0,0,8)
`}
`;
const Line = styled.div`
  width: 100%;
  height: 1px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 20px;
`;

const TotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;
const FloorDiscountContainer = styled.div``;
const FloorPrice = styled.text`
  font-weight: 400;
  font-size: 16px;
  font-family: sans-serif;
  line-height: 19px;
  color: #ffffff;
`;
const Span2 = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  padding: 0 25px;
`;
const Total = styled.text`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  font-family: sans-serif;
  color: #ffffff;
`;
const DropdownContainer = styled.div``;
const DropDownTextWrapper = styled.div`
  display: flex;
`;
const Dropdown = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  font-family: sans-serif;
  color: #ffffff;
`;
const ButtonWrapper2 = styled.div`
  margin: 30px 0;
  width: 100%;
`;
const Button2 = styled.button`
  color: #88fefe;
  background: #203736;
  width: 100%;
  padding: 18px;
  border-radius: 30px;
  font-size: 18px;
  outline: none;
  border: none;
  cursor: pointer;
`;

const SelectContainer = styled.div``;
const Select = styled.select`
  margin: 0 30px;
  padding: 5px 20px;
  font-size: 18px;
  border-radius: 10px;
  cursor: pointer;
  border: none;
  outline: none;
`;
const Option = styled.option`
  cursor: pointer;
`;

const NameWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  text-align: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 0 0 30px 0px;
  border-bottom: 1px solid #2a2a2a;
  padding-bottom: 30px;
  width: 100%;
`;
const NameText = styled.text`
  font-size: 46px;
  font-weight: 600;
  text-transform: capitalize;
  text-align: left;
`;
const NameTextMain = styled.text`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;
const SubCategory = styled.text`
  font-size: 20px;
  padding-bottom: 10px;
  color: #0a92ae;
`;

const NftCategory = styled.div`
  font-size: 14px;
  font-weight: 800;
  color: #490d81;
  text-transform: uppercase;
  background-color: #d3b1f3;
  padding: 10px 30px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  ${(p) =>
    p.rare &&
    `
    background-color: #a5e3b8;
    color: #2b713e;
  `};
  ${(p) =>
    p.common &&
    `
    background-color: #dddddd;
    color: #535353;
  `};
`;

const CollectionText = styled.div`
  display: flex;
  padding-top: 20px;
  align-items: center;
`;
const PayButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CollectionTextHead = styled.div`
  font-size: 16px;
  color: #6a6a6a;
  font-weight: 600;
`;

const CollectionTextName = styled.div`
  font-size: 22px;
  color: #dfdfdf;
`;

const CollectionTextFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
`;

const CollectionImg = styled.img`
  width: 60px;
  height: 60px;
  padding: 10px;
  /* background-color: #000; */
  background: linear-gradient(266deg, #1c1f24, #11262c);
  border-radius: 10px;
`;

const NftCategoryHash = styled.div`
  display: flex;
`;

const NftHash = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
`;

const LordImage = styled.img`
  width: 25px;
  margin-right: 10px;
`;

const NftNameConfirm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: center;
  ${(p) => {
    p.ConfirmPopup &&
      `
   justify-content: flex-start;
  `;
  }}
`;
const NftConfirmImg = styled.img`
  width: 60px;
  height: 60px;
  background-color: #fff;
  border-radius: 10px;
`;
const NftNameConfirmHead = styled.div`
  font-size: 32px;
  font-weight: 500;
  // text-align: center;
`;
const NftNameConfirmHeadUn = styled.div`
  text-align: center;
`;
const NftNameConfirmSubHead = styled.div`
  font-size: 16px;
  color: #bbb;
  text-transform: capitalize;
`;
const NftAmountConfirm = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0 0;
`;
const NftAmountConfirmHeadPur = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;
const NftAmountConfirmHead = styled.div`
  font-size: 24px;
`;
const NftAmountConfirmSubHead = styled.div`
  font-size: 24px;
`;
const NftAmountConfirmHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;
const NftAmountConfirmSubHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;

const NftNameConfirmHash = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
  max-height: 35px;
  justify-content: space-between;
  width: 105px;
`;

const NameandcategoriesWrapper = styled.div`
  // margin: 0 0 0 20px;
`;

const DialogStyledUpdate = styled(Dialog)``;
const InitInProgressWrapper = styled.div``;

const TextContractContainer = styled.div`
  margin: 1.5rem 0;
`;

const ContractTextWrapper = styled.div`
  margin: 10px 0;
`;
const ContractText = styled.text`
  font-size: 24px;
  font-family: sans-serif;
  font-weight: 500;
  color: #fff;
`;

const PopupButton = styled(Button)`
  background: linear-gradient(45deg, #0a5d6e, #00aacd);
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 24px;
  padding: 20px 80px;
  margin: 40px 0 10px;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  -webkit-transition: 1s;
  transition: 1s;
`;
export default NftBidingDetailpage;
